import type { ITokenModel } from '@delon/auth';
import type { Auth, NuasApp } from '@eliboo/api-models';

import { Component, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { DA_SERVICE_TOKEN } from '@delon/auth';
import { CacheService } from '@delon/cache';
import { decode } from 'js-base64';
import { catchError, map, of, switchMap } from 'rxjs';

import { AppService } from '../core/api/app.service';

export function getTokenModel(data: Auth.Oauth2TokenDto) {
  const user: ITokenModel = {
    ...data,
    token: data.tokenHead! + data.token,
    time: +new Date(),
    expired: new Date().getTime() + data.expiresIn! * 1000,
    refresh_token: data.refreshToken,
  };
  return user;
}

interface TransferData {
  params: Record<string, string>; //  目标路由参数
  path: string; //  目标路由路径
  tokenDto: Auth.Oauth2TokenDto;
  userId: string; //  用户id
}
const defaultUrl = '/';
const errorUrl = '/';
@Component({
  selector: 'app-transfer',
   
  standalone: false,
  template: `
    <div class="loading-container">
      <nz-spin nzSimple></nz-spin>
    </div>
  `,
  styles: [
    `
      .loading-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100vw;
        height: 100vh;
      }
    `,
  ],
})
export class TransferComponent {
  private readonly route = inject(ActivatedRoute);
  private readonly router = inject(Router);
  private readonly tokenService = inject(DA_SERVICE_TOKEN);
  private readonly cacheService = inject(CacheService);
  private readonly appService = inject(AppService);

  _skipAppInit = signal('');

  constructor() {
    const queryString = window.location.search; // 获取URL中的查询字符串部分
    const urlParams = new URLSearchParams(queryString);
    this._skipAppInit.set(urlParams.get('_skipAppInit') || '');

    this.route.queryParams
      .pipe(
        takeUntilDestroyed(),
        map((params) => {
          const data = params['_data'];
          const transferData: null | TransferData = null;
          if (data) {
            const decodedString = decode(data);
            const transferData: TransferData = JSON.parse(decodedString);
            return transferData;
          }
          return transferData;
        }),
        switchMap((transferData) => {
          console.log('tra', transferData);

          let url = transferData?.path || defaultUrl;
          url = url.startsWith('/') ? url : `/${url}`;
          // if (transferData) {
          //   this.tokenService.set(getTokenModel(transferData.tokenDto));
          //   if (this._skipAppInit() == 'true') {
          //     return this.appService.init().pipe(map(() => ({ url, params: {} })));
          //   } else {
          //     if (!this.checkIsSameUser(transferData.userId)) {
          //       return this.appService.init().pipe(map(() => ({ url, params: {} })));
          //     }
          //   }
          // }
          this.cacheService.set('token', transferData?.tokenDto.token);
          return of({
            url,
            params: {
              supplemtyInfo: transferData?.params['supplemtyInfo'] || false,
            },
          });
        }),
        catchError(() => of({ url: errorUrl, params: {} })),
      )
      .subscribe((routeParams) => {
        this.router.navigate([routeParams.url], { replaceUrl: true, queryParams: routeParams.params });
      });
  }

  private checkIsSameUser(userId: string): boolean {
    const currentUser = this.cacheService.getNone('user') as NuasApp.NuasMemberUserAccountAndBaseInfoDTO;
    const currentUserId = currentUser?.nuasMemberUserBaseInfoDTO?.memberUserUnionId;
    return !!(currentUserId && currentUserId.toString() === userId.toString());
  }
}
